/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { environment } from 'utils/environment';



/* --------------- UTILITIES : URLs --------------- */
// set host URL based on dynamic environment variable
let hostURL;
let siteurl;
let apiURL;
let distributionURL;
let shutterStockUrl;
let shutterStockKey;
let unsplashUrl;
let unsplashKey;
let pubAPI;
let baseurl;
let embedAPI;
let rmsAPI;

// const tempAccountUUID = `72f2ab54-2c18-464f-8387-002d4b6ef9eb`;
// troy - e18e561c-a02a-436a-8775-e83420027e95
// jonathan - f23817ed-9718-4f2a-80c4-b1ddee7db2cf
// jonathan - 11b9cd46-37b2-47f2-9b46-c9db600079f6

// populate hostURL with proper amazon s3 bucket url based on environment
switch (environment) {
    case 'PRODUCTION':
        hostURL = 'https://df80k0z3fi8zg.cloudfront.net';
        distributionURL = 'https://dzh3i6aoot1g7.cloudfront.net';
        siteurl = 'insticator';
        baseurl = 'insticator.com';
        apiURL = 'https://mks.insticator.com';
        shutterStockUrl = 'https://api.shutterstock.com/v2/images/search';
        shutterStockKey = 'v2/YmNkY2ItZGEyZGItMTRlN2EtNjAyZDctYzllZTgtMjBkYTUvMjA4MDIzMzcxL2N1c3RvbWVyLzMvVHJuS1ZmT09zeFZNd3VHSFRfbUVPM2JmTXJ2N2NmUU1RNnVRZ2pHRFpjbXMzdHRHQVFOR25aWmw0dUtXQWlXam1jUHdIZF9YWGtHY2x5RHFFdmtzOE0yVFBqSFNSYU1SdlMwNEh6OHc1UW05X01hX0dMQzY0dWdaWXhBdTUxMnlSc3VlcS1NVVhWTkZOVEg4eTFQWjZ6VzAyUzhpNDNVUEVubTZhNGJ4VHRJN3h4dzVvMDhaY1MwaERrcElfSlVZdER3UERraS1McEM1ZlA4dnFHOHdLUQ';
        unsplashUrl =  'https://api.unsplash.com/search/photos';
        unsplashKey =  'c576cd7364ce61348c2e72ba81182b4f818b93972ed075619fed67d3b9fbe85a';
        //new publisher portal API (To be updated)
        pubAPI = 'https://ppa.insticator.com';
        embedAPI = 'https://dashboard.insticator.com';
        rmsAPI = 'https://rms.insticator.com';
        break;
    case 'STAGING':
        hostURL = 'https://d1kxobflaipx1q.cloudfront.net';
        distributionURL = 'https://dchetohgcb1b1.cloudfront.net';
        siteurl = 'hunchme';
        baseurl = 'hunchme.com';
        apiURL = 'https://mks.hunchme.com';
        shutterStockUrl = 'https://api-sandbox.shutterstock.com/v2/images/search';
        shutterStockKey = 'v2/Y2E3ZWEtNWE1NDEtZDMwMGEtMGVmMzktZmNkMjEtY2Q5NzUvMjA2MTYyNzU1L2N1c3RvbWVyLzMvU1dHNGxvbkl5eFdJalJ6YWJtTFNQc1NUTFJBWVhEOFluaFN2R0dZWEU3MlFrM2l3UlYwTi1SN3hRM0g3YUxrNjlaY0ZKU0JVQ2hmbktNTmljc3h3N0lpRTRRUHQxek9QdmF5V3F6MDRyRU90YzBMZy1xQThzSFNGeUEzUjI5ZnVqdWZqc1locnJETXBiNlZGM29UR3ROYXpFYkszbGR5ZG1hWnlGM3ZuRHYzclJTYXRYTnRGODZFSlVja0U4UDN4aWlMT1NmdXY1QlhGRTdHM0xzMExJUQ';
        unsplashUrl =  'https://api.unsplash.com/search/photos';
        unsplashKey =  'c576cd7364ce61348c2e72ba81182b4f818b93972ed075619fed67d3b9fbe85a';
        //new publisher portal API (To be updated)
        pubAPI = 'https://ppa.hunchme.com';
        embedAPI = 'https://dashboard.hunchme.com';
        rmsAPI = 'https://rms.hunchme.com';
        break;
    case 'REVIEW':
        hostURL = 'https://d1kxobflaipx1q.cloudfront.net';
        distributionURL = 'https://dchetohgcb1b1.cloudfront.net';
        siteurl = 'hunchme';
        baseurl = 'hunchme.com';
        apiURL = 'https://mks.hunchme.com';
        shutterStockUrl = 'https://api-sandbox.shutterstock.com/v2/images/search';
        shutterStockKey = 'v2/Y2E3ZWEtNWE1NDEtZDMwMGEtMGVmMzktZmNkMjEtY2Q5NzUvMjA2MTYyNzU1L2N1c3RvbWVyLzMvU1dHNGxvbkl5eFdJalJ6YWJtTFNQc1NUTFJBWVhEOFluaFN2R0dZWEU3MlFrM2l3UlYwTi1SN3hRM0g3YUxrNjlaY0ZKU0JVQ2hmbktNTmljc3h3N0lpRTRRUHQxek9QdmF5V3F6MDRyRU90YzBMZy1xQThzSFNGeUEzUjI5ZnVqdWZqc1locnJETXBiNlZGM29UR3ROYXpFYkszbGR5ZG1hWnlGM3ZuRHYzclJTYXRYTnRGODZFSlVja0U4UDN4aWlMT1NmdXY1QlhGRTdHM0xzMExJUQ';
        unsplashUrl =  'https://api.unsplash.com/search/photos';
        unsplashKey =  'c576cd7364ce61348c2e72ba81182b4f818b93972ed075619fed67d3b9fbe85a';
        //new publisher portal API (To be updated)
        pubAPI = 'https://ppa.hunchme.com';
        embedAPI = 'https://dashboard.hunchme.com';
        rmsAPI = 'https://rms.hunchme.com';
        break;
    case 'BETA':
        hostURL = 'https://d1kxobflaipx1q.cloudfront.net';
        distributionURL = 'https://dchetohgcb1b1.cloudfront.net';
        siteurl = 'hunchme';
        baseurl = 'hunchme.com';
        apiURL = 'https://mks.hunchme.com';
        shutterStockUrl = 'https://api-sandbox.shutterstock.com/v2/images/search';
        shutterStockKey = 'v2/Y2E3ZWEtNWE1NDEtZDMwMGEtMGVmMzktZmNkMjEtY2Q5NzUvMjA2MTYyNzU1L2N1c3RvbWVyLzMvU1dHNGxvbkl5eFdJalJ6YWJtTFNQc1NUTFJBWVhEOFluaFN2R0dZWEU3MlFrM2l3UlYwTi1SN3hRM0g3YUxrNjlaY0ZKU0JVQ2hmbktNTmljc3h3N0lpRTRRUHQxek9QdmF5V3F6MDRyRU90YzBMZy1xQThzSFNGeUEzUjI5ZnVqdWZqc1locnJETXBiNlZGM29UR3ROYXpFYkszbGR5ZG1hWnlGM3ZuRHYzclJTYXRYTnRGODZFSlVja0U4UDN4aWlMT1NmdXY1QlhGRTdHM0xzMExJUQ';
        unsplashUrl =  'https://api.unsplash.com/search/photos';
        unsplashKey =  'c576cd7364ce61348c2e72ba81182b4f818b93972ed075619fed67d3b9fbe85a';
        //new publisher portal API (To be updated)
        pubAPI = 'https://ppa.hunchme.com';
        embedAPI = 'https://dashboard.hunchme.com';
        rmsAPI = 'https://rms.hunchme.com';
        break;
    case 'LOCALHOST':
        hostURL = 'https://drhn9v8cwg89y.cloudfront.net';
        apiURL = 'http://localhost:8888';
        distributionURL = 'https://d2jxnpxaf6d8ub.cloudfront.net';
        siteurl = 'hunchme';
        baseurl = 'localhost';
        shutterStockUrl = 'https://api-sandbox.shutterstock.com/v2/images/search';
        shutterStockKey = 'v2/Y2E3ZWEtNWE1NDEtZDMwMGEtMGVmMzktZmNkMjEtY2Q5NzUvMjA2MTYyNzU1L2N1c3RvbWVyLzMvU1dHNGxvbkl5eFdJalJ6YWJtTFNQc1NUTFJBWVhEOFluaFN2R0dZWEU3MlFrM2l3UlYwTi1SN3hRM0g3YUxrNjlaY0ZKU0JVQ2hmbktNTmljc3h3N0lpRTRRUHQxek9QdmF5V3F6MDRyRU90YzBMZy1xQThzSFNGeUEzUjI5ZnVqdWZqc1locnJETXBiNlZGM29UR3ROYXpFYkszbGR5ZG1hWnlGM3ZuRHYzclJTYXRYTnRGODZFSlVja0U4UDN4aWlMT1NmdXY1QlhGRTdHM0xzMExJUQ';
        unsplashUrl =  'https://api.unsplash.com/search/photos';
        unsplashKey =  'c576cd7364ce61348c2e72ba81182b4f818b93972ed075619fed67d3b9fbe85a';
        //new publisher portal API (To be updated)
        pubAPI = 'http://localhost:5000';
        embedAPI = 'http://localhost:5002';
        rmsAPI = 'http://localhost:7788';
        break;
    default:
        hostURL = 'https://drhn9v8cwg89y.cloudfront.net';
        distributionURL = 'https://dchetohgcb1b1.cloudfront.net';
        siteurl = 'hunchme';
        baseurl = 'hunchme.com';
        shutterStockUrl = 'https://api-sandbox.shutterstock.com/v2/images/search';
        unsplashUrl =  'https://api.unsplash.com/search/photos';
        unsplashKey =  'c576cd7364ce61348c2e72ba81182b4f818b93972ed075619fed67d3b9fbe85a';
        //new publisher portal API (To be updated)
        pubAPI = 'https://ppa.hunchme.com';
        embedAPI = 'https://dashboard.hunchme.com';
        rmsAPI = 'https://rms.hunchme.com';
        break;
}
// store URLs for export
const url = {
    baseurl: baseurl,
    image: {
        app: `${hostURL}/files/images/publisherportal`,
        client: `${hostURL}/files/images/publisherportal/client`,
    },
    company: `https://www.${siteurl}.com`,
    dashboard: {
        base: `https://dashboard.${siteurl}.com`,
        dashboardMessage: `https://dashboard.${siteurl}.com/dashboardmessage`
    },
    api: {
        clientsImages: `${apiURL}/v1/clients/images`,
        embeds: `${apiURL}/v1/embeds`,
        embedsClient: `${apiURL}/v1/embeds/client`
    },
    giphy: {
        search: 'https://api.giphy.com/v1/gifs/search?api_key=7Z900XNNUvlLNKVTENIREXqhJJLKlYob&limit=40&offset=0&rating=G&lang=en&q=',
        default:'https://api.giphy.com/v1/gifs/trending?api_key=7Z900XNNUvlLNKVTENIREXqhJJLKlYob&limit=40&rating=G&lang=en'
    },
    shutterStock: {
        search: `${shutterStockUrl}?license=editorial&per_page=40`,
        headers: { 'Authorization': `Bearer ${shutterStockKey}`}
    },
    unsplash: {
        search: `${unsplashUrl}?per_page=30`,
        headers: {'Authorization': `Client-ID ${unsplashKey}`,'Accept-Version': 'v1'}
    },
    social: {
        facebook: `https://www.facebook.com/insticator/`,
        twitter: `https://twitter.com/Insticator_inc`,
        linkedin: `https://www.linkedin.com/company/insticator`
    },
    embedSrc: `${distributionURL}/embed-core/embed_core.js`,
    accountSettings: {
        general: `${pubAPI}/v1/accounts`,
        getAgreement: `${pubAPI}/v1/accounts`,
        updateAgreement: `${pubAPI}/v1/agreements`
    },
    usersSettings: {
        base: `${pubAPI}/v1/users`,
    },
    auth: {
        // signIn: `${pubAPI}/v1/callback?client_name=FormClient`,
        usersAPI: `${pubAPI}/v1/users`,
        signIn: `${pubAPI}/v1/auth/login`,
        signOut: `${pubAPI}/v1/auth/logout`,
        googleAuth: `${pubAPI}/v1/auth/google`,
        createLead: `${pubAPI}/v1/leads`,
        sendResetEmail: `${pubAPI}/v1/auth/password/send-email`,
        resetPassword: `${pubAPI}/v1/auth/reset-password`,
        getTokenData: `${pubAPI}/v1/auth/token`,
        createUser: `${pubAPI}/v1/auth/profile`,
        unmockUser: `${pubAPI}/v1/auth/unmock`,
        extendSession: `${pubAPI}/v1/auth/extend-session`
    },
    embeds: {
        base: `${pubAPI}/v1/embeds`
    },
    sites: {
        base: `${pubAPI}/v1/sites`
    },
    accounts: {
        base: `${pubAPI}/v1/accounts`,
        images: `${pubAPI}/v1/accounts/images`,
    },
    reports: {
        base: `${pubAPI}/v1/report`,
        run: `${rmsAPI}/v1/clientreport`
    },
    users:{
      base: `${pubAPI}/v1/users`,
      getUsers: `${pubAPI}/v1/accounts/`,
      addUser: `${pubAPI}/v1/accounts/`,
      updateUser:`${pubAPI}/v1/users/`,
      resendInvite: `${pubAPI}/v1/auth/resend/user-invite`
    },
    getSiteCountriesEmbeds: `${pubAPI}/v1/accounts/`,
    homeAnalytics: {
        getTotalQuestionsAnswered: `${pubAPI}/v1/metrics/question-answered/total`,
        getTotalTopQuestionsAnswered: `${pubAPI}/v1/metrics/question-answered/top-questions`,
        getTotalAverageInView: `${pubAPI}/v1/metrics/embed-load/total`,
        getTotalUniqueEngagedUsers: `${pubAPI}/v1/metrics/unique-engaged-users/total`,
        getTotalTopStoriesClicked: `${pubAPI}/v1/metrics/story-clicked/top-stories`,
        getTotalStoryClicks: `${pubAPI}/v1/metrics/story-clicked/total`,
        getTotalRevenueMetrics: `${rmsAPI}/v1/metrics/revenue/total`
    },
    detailAnalytics:{
        getDetailQuestionsAnswered: `${pubAPI}/v1/metrics/question-answered/detailed`,
        getDetailTopQuestionsAnswered: `${pubAPI}/v1/metrics/question-answered/top-questions`,
        getDetailAverageInView: `${pubAPI}/v1/metrics/embed-load/detailed`,
        getDetailUniqueEngagedUsers: `${pubAPI}/v1/metrics/unique-engaged-users/detailed`,
        getDetailTopStoriesClicked: `${pubAPI}/v1/metrics/story-clicked/top-stories`,
        getDetailStoriesClicked: `${pubAPI}/v1/metrics/story-clicked/detailed`,
        getDetailRevenueMetrics: `${rmsAPI}/v1/metrics/revenue/detail`,
    },
    paymentInformation: `${pubAPI}/v1/accounts`,
    existingPaymentInformation: `${pubAPI}/v1/paymentinfo`,
    adsTxt: {
        getAdsTxt: `${embedAPI}/sites/publisher-portal/getadstxt`,
        verifyAdsTxt: `${embedAPI}/sites/publisher-portal/verifyadstxt`
    },
    embedLogin: {
        unmockRedirect: `${embedAPI}/admin/login`
    },
    getPageResource: `${embedAPI}/utils/getopengraphparams`
};

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export { url };
